export default __webpack_public_path__ + "static/media/HaloWhite.3151eb8b.svg";